<form [formGroup]="form" [waiting]="loadingService.isLoading$(this) | async">
  <div class="row h-full">
    <div class="col grow">
      <icz-form-autocomplete
        formControlName="registryOfficeId"
        label="Zvolte spisovnu"
        [options]="registryOfficeOptions"
      ></icz-form-autocomplete>
      @for (transferPrepareError of transferPrepareErrors; track transferPrepareError) {
        <div class="row mb-8">
          <icz-icon
            withCustomIconColor class="severity-icon h-24"
            [class]="getEsslSeverityIconClass(transferPrepareError.severity)"
            [svgIcon]="getEsslSeverityIcon(transferPrepareError.severity)"
          ></icz-icon>
          <div class="icz-body-1 grow">
            <div class="icz-body-strong">{{ getTransferrableObjectTitle(transferPrepareError.transferrableObject) }}:</div>
            <icz-markdown-template-outlet
              [template]="transferPrepareError.errorCode | translate"
              [templateContext]="transferPrepareError.errorContext"
              [templateContextSchema]="errorContextSchema"
            ></icz-markdown-template-outlet>
            @for (file of transferPrepareError.relatedFiles; track file.id) {
              <icz-entity-info [entity]="file" [isLink]="false"></icz-entity-info>
            }
          </div>
        </div>
      }
    </div>
  </div>
</form>

<icz-form-buttons>
  <icz-button leftButtons iczFormSubmit
              [disabled]="loadingService.isLoading(this) || hasTransferPrepareFailures"
              (onAction)="submit()"
              primary label="Předat do spisovny"
  ></icz-button>
  <icz-button rightButtons
              [disabled]="loadingService.isLoading(this)"
              (onAction)="cancel()" label="Storno"
  ></icz-button>
</icz-form-buttons>
